import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, allowedRoles, permKey }) {
  const { user, loading } = useAuth();
  const [slow, setSlow] = React.useState(false);
  React.useEffect(() => {
    if (!loading) return;
    const t = setTimeout(() => setSlow(true), 3000);
    return () => clearTimeout(t);
  }, [loading]);
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 gap-3">
        <div className="text-xs font-bold uppercase tracking-overline text-slate-500">Lädt…</div>
        {slow && (
          <div className="text-[11px] text-slate-500 max-w-sm text-center px-4">
            Verbindung zum Server dauert länger als erwartet. Falls das gleich bleibt:
            <br /><a href="/login" className="underline">Neu einloggen</a> oder Seite neu laden (Strg+Shift+R).
          </div>
        )}
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  const hasPerms = Array.isArray(user.permissions) && user.permissions.length > 0;
  let allowed = true;
  if (user.is_master_admin || user.role === "admin") {
    allowed = true;
  } else if ((permKey === "vertraege" && user.can_edit_contracts) || (permKey === "unterlagen" && user.can_doc_check) || (permKey === "traegerbestaetigung" && (user.all_roles || [user.role]).includes("manager"))) {
    allowed = true;
  } else if (permKey && hasPerms) {
    allowed = user.permissions.includes(permKey);
  } else if (Array.isArray(allowedRoles) && allowedRoles.length > 0) {
    const roles = Array.isArray(user.all_roles) && user.all_roles.length ? user.all_roles : [user.role];
    allowed = roles.some((r) => allowedRoles.includes(r));
  }
  if (!allowed) {
    // Send them to their own home page
    const home =
      user.role === "client" ? "/mein-bereich"
      : user.role === "participant" ? "/weiterbildung/mein-bereich"
      : "/dashboard";
    return <Navigate to={home} replace />;
  }
  return children;
}
